import { model as router, type RouterState } from '!/router'
import { type PlayerSearchParams } from '../types'
import { addSearchParamsToPath } from './url'

/**
 * Navigates to a specified path with search parameters
 * @param path - The path to navigate to
 * @param searchParams - Search parameters to add to the path
 * @param state - Optional state object to pass with navigation
 * @returns void
 *
 * @example
 * // Navigate with state object
 * navigateTo('/live/channel-123/play', { category: '1124' }, { from: 'epg' })
 * will navigate to '/live/channel-123/play?category=1124'
 */
export const navigateTo = (
  path: string,
  searchParams: PlayerSearchParams,
  state?: RouterState
) => {
  const pathObj = addSearchParamsToPath({
    params: searchParams,
    path,
  })
  return router.navigateReplace({
    pathname: pathObj,
    state,
  })
}
